import { RouterProvider } from 'react-router-dom'

import ConnectivityToasts from '@/components/ConnectivityToasts'
import { router } from './router'

export default function App() {
	return (
		<>
			<RouterProvider router={router} />
			<ConnectivityToasts />
		</>
	)
}
